<ngx-extended-pdf-viewer [(src)]="pdfSrc" [useBrowserLocale]="true" [pageViewMode]="pageViewMode" [textLayer]="false"
    [showHandToolButton]="false" [showToolbar]="false" [sidebarVisible]="false" [zoom]="'auto'"
    (pageRendered)="onPagesRendered($event)" (pdfLoaded)="pdfLoaded( $event)" (pagesLoaded)="onPagesLoaded($event)"
    [enablePinchOnMobile]="true" useBrowserLocale="true" width="100%" height="95vh">
</ngx-extended-pdf-viewer>